const ZoomLabelMapping = [
    '1x','1x','1x','1x','1x','1x','1x','1x', // Zoom 0..7
    '2x','2x', // Zoom 8..9
    '3x','3x', // Zoom 10..11
    '4x','4x', // Zoom 12..13
    '5x','5x','5x','5x','5x','5x','5x','5x','5x','5x','5x' // Zoom 14+
]

export default function getZoomLabel(zoom) {
    return ZoomLabelMapping[zoom]
}